import { render, staticRenderFns } from "./integrationsMetaForm.vue?vue&type=template&id=8f31b31a&scoped=true"
import script from "./integrationsMetaForm.vue?vue&type=script&lang=js"
export * from "./integrationsMetaForm.vue?vue&type=script&lang=js"
import style0 from "./integrationsMetaForm.vue?vue&type=style&index=0&id=8f31b31a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f31b31a",
  null
  
)

export default component.exports